import styled from 'styled-components';
import Modal from 'react-modal';

import breakpoints, { breakpointsDesktopFirst } from '../../themes/breakpoints';

const modalPadding = '0 0 2px 0';
// const buttonPadding = '2em';

export const ModalTitle = styled.div`
  font-size: 1.1rem;
  line-height: 3rem;
  height: 52px;
  vertical-align: center;
  font-weight: bold;
  text-align: left;
  width:100%;
  border-bottom: 1px solid #E2E2E2;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
`;

export const ModalBody = styled.div`
  padding: 22px 20px;
  display: flex;
  flex-direction: column;
`;

export const Dimension = styled.div`
  width: 176px;
`;

export const GccInput = styled.div`
  min-width: 78px;
  height: 41px;
  vertical-align: top;
  font-size: 1rem;
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0 10px 22px 0;
  padding: 0;
  border: 0;
  outline: 0;

  input {
    color: #1c2833;
    outline: 0;
    padding-top: 13px;
    padding-bottom: 0;
    height: 41px;
    border: 2px solid #dadedf;
    background: #ffffff;
    text-indent: 8px;
    cursor: default;
    line-height: 1.5;
    position: absolute;
    transition: all .15s ease;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    padding-left: 0px;
    display: inline-block;
  }
  label {
    line-height: 1;
    margin-top: 6px;
    font-size: .7rem;
    position: absolute;
    left: 0;
    text-align: left;
    color: #707c80;
    pointer-events: none;
    cursor: default;
    transition: all .15s ease;
    box-sizing: border-box;
    padding-left: 10px;
    font-weight: normal;
    width: 100%;
  }
`;

export const GccTextArea = styled.div`
  min-width: 78px;
  min-height: 91px;
  vertical-align: top;
  font-size: 1rem;
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0 10px 22px 0;
  padding: 0;
  border: 0;
  outline: 0;
  textarea {
    color: #1c2833;
    outline: 0;
    padding-top: 13px;
    padding-bottom: 0;
    min-height: 91px;
    border: 2px solid #dadedf;
    background: #ffffff;
    cursor: default;
    line-height: 1.5;
    position: absolute;
    transition: all .15s ease;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    padding-left: 8px;
    display: block;
    font-size: 1rem;
  }
  label {
    line-height: 1;
    margin-top: 6px;
    font-size: .7rem;
    position: absolute;
    left: 0;
    text-align: left;
    color: #707c80;
    pointer-events: none;
    cursor: default;
    transition: all .15s ease;
    box-sizing: border-box;
    padding-left: 10px;
    font-weight: normal;
    width: 100%;
  }  
`;

export const GccDropdown = styled.div`
  min-width: 78px;
  height: 41px;
  vertical-align: top;
  font-size: 1rem;
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0 10px 22px 0;
  padding: 0;
  border: 0;
  outline: 0;

  &:before {
    position: absolute;
    content: "▾";
    z-index: 1;
    font-family: sans-serif;
    color: #1c2833;
    pointer-events: none;
    right: .7rem;
    top: .7rem;
    font-size: 1rem;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    right: 2px;
    bottom: 2px;
    top: 2px;
    width: 20px;
    background: #ffffff;
    border-radius: 0 4px 4px 0;
    pointer-events: none;
  }

  select {
    color: #1c2833;
    outline: 0;
    padding-top: 13px;
    padding-bottom: 0;
    height: 41px;
    border: 2px solid #dadedf;
    background: #ffffff;
    text-indent: 8px;
    cursor: default;
    line-height: 1.5;
    position: absolute;
    transition: all .15s ease;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    padding-left: 0px;
    display: inline-block;
  }

  label {
    line-height: 1;
    margin-top: 6px;
    font-size: .7rem;
    position: absolute;
    left: 0;
    text-align: left;
    color: #707c80;
    pointer-events: none;
    cursor: default;
    transition: all .15s ease;
    box-sizing: border-box;
    padding-left: 10px;
    font-weight: normal;
    width: 100%;
  }

`;

export const DimensionType = styled.div`
  font-size: 16px;
  font-weight:bold;
  line-height: 22px;
  margin-bottom: 10px;
`;

export const Dimensions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const DimensionGccDropdown = styled(GccDropdown)`
  display: inline-block;
`;

export const CloseModalButton = styled.div`
    width: 36px;
    height: 36px;
    margin-top: 4px;
    margin-right: 4px;
    cursor: pointer;
    font-weight: 400;
`;

export const Verification = styled.div`
  margin-bottom: 22px;
`;

export const Error = styled.div`
  margin: -17px 0 5px 0;
  color: #C02F1D;
  font-size: 11px;
  height: 17px;
`;

export const SaveButton = styled.button`
  width: calc(100% - 20px);
  text-align:center;
  padding: 10px;
  color: #FFFFFF;
  border-radius: 4px;
  border-color: #F96302;
  border-width: 1px;
  border-style: solid;
  background-color: #F96302;
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  &:hover {
    background-color: #df5902;
  }
  &:disabled {
    background-color: #C1C7C9;
    border-color: #C1C7C9;
  }
`;

export const ResponsiveMandiEditAttributesModal = styled(Modal)`
position: absolute;
width: 596px;
height: 586px;
background-color: white;
padding: ${modalPadding};
border-radius: 10px;

top: 50%;
left: 50%;
transform: translate(-50%, -50%);

@media ${breakpointsDesktopFirst.tablet} {
  padding-bottom: 70px;
}

@media ${breakpoints.desktopSmall} {
  max-height: 90vh;
  min-height: 620px;
}
`;
